export default class Printer {
  public static ZEBRA = 'zebra';

  public static PACKAGER = 'packager';
}
